import { createSelector } from "reselect";

import { scalePixelsToFontSize } from "../../../constants/styles/dimensions";
import timelineViewConstants from "../../../constants/styles/timelineView";

export const getLayoutConstants = createSelector(
  // fetch parameters for last calculate function
  (fontSize, _showItemCard) => fontSize,
  (_fontSize, showItemCard) => showItemCard,
  // Calculate result
  (fontSize, showItemCard) => {
    const TIMELINE_BOTTOM_PADDING = scalePixelsToFontSize(timelineViewConstants.TIMELINE_BOTTOM_PADDING, fontSize);
    const GROUP_HEADER_HEIGHT = scalePixelsToFontSize(timelineViewConstants.GROUP_HEADER_HEIGHT, fontSize);
    const GROUP_TOP_PADDING = scalePixelsToFontSize(timelineViewConstants.GROUP_TOP_PADDING, fontSize);

    // Sizes to use when ItemCard is showing
    if (showItemCard) {
      const EVENT_RECT_PADDING = scalePixelsToFontSize(7, fontSize);
      const MARKER_HEIGHT = scalePixelsToFontSize(timelineViewConstants.MARKER_HEIGHT, fontSize);
      const MARKER_BOTTOM_MARGIN = scalePixelsToFontSize(2, fontSize);
      const PARENT_MARKER_OFFSET = 0;
      const LAYOUT_LINE_HEIGHT = MARKER_HEIGHT + MARKER_BOTTOM_MARGIN + PARENT_MARKER_OFFSET;

      return {
        EVENT_RECT_PADDING,
        EVENT_RECT_PADDING_TOP_TEXT: scalePixelsToFontSize(5, fontSize),
        MARKER_HEIGHT,
        MARKER_BOTTOM_MARGIN,
        LAYOUT_LINE_HEIGHT,
        MARKER_RIGHT_MARGIN: scalePixelsToFontSize(8, fontSize),
        MARKER_NEW_LINE_WIDTH: scalePixelsToFontSize(200, fontSize),
        EVENT_RECT_MARGIN: scalePixelsToFontSize(2, fontSize),
        CHILDREN_ARROW_SIZE: scalePixelsToFontSize(14, fontSize),
        CHILDREN_ARROW_LEFT_MARGIN: scalePixelsToFontSize(10, fontSize),
        CHILDREN_ARROW_ONE_LINE_TOP: EVENT_RECT_PADDING,
        CHILDREN_ARROW_NEW_LINE_TOP: scalePixelsToFontSize(13, fontSize),
        CHILDREN_BORDER_LEFT_PADDING: scalePixelsToFontSize(8, fontSize),
        CHILDREN_BORDER_RIGHT_PADDING: scalePixelsToFontSize(14, fontSize),
        CHILDREN_BORDER_BOTTOM_PADDING: scalePixelsToFontSize(2, fontSize),
        CHILDREN_BORDER_BOTTOM_MARGIN: scalePixelsToFontSize(2, fontSize),
        PARENT_MARKER_OFFSET,
        TIMELINE_BOTTOM_PADDING,
        GROUP_HEADER_HEIGHT,
        GROUP_TOP_PADDING
      };
    }

    // Sizes to use when we are showing the Marker and nothing more

    const EVENT_RECT_PADDING = 0;
    const MARKER_HEIGHT = scalePixelsToFontSize(timelineViewConstants.MARKER_HEIGHT_NO_CARD, fontSize);
    const MARKER_BOTTOM_MARGIN = scalePixelsToFontSize(2, fontSize);
    const PARENT_MARKER_OFFSET = scalePixelsToFontSize(timelineViewConstants.PARENT_SHADOW_OFFSET, fontSize);
    const EVENT_RECT_MARGIN = scalePixelsToFontSize(2, fontSize);

    const LAYOUT_LINE_HEIGHT = MARKER_HEIGHT + MARKER_BOTTOM_MARGIN + PARENT_MARKER_OFFSET + EVENT_RECT_MARGIN;

    return {
      EVENT_RECT_PADDING,
      EVENT_RECT_PADDING_TOP_TEXT: scalePixelsToFontSize(5, fontSize),
      MARKER_HEIGHT,
      MARKER_BOTTOM_MARGIN,
      LAYOUT_LINE_HEIGHT,
      MARKER_RIGHT_MARGIN: 0,
      MARKER_NEW_LINE_WIDTH: scalePixelsToFontSize(200, fontSize),
      EVENT_RECT_MARGIN,
      CHILDREN_ARROW_SIZE: scalePixelsToFontSize(14, fontSize),
      CHILDREN_ARROW_LEFT_MARGIN: scalePixelsToFontSize(-2, fontSize),
      CHILDREN_ARROW_ONE_LINE_TOP: 0,
      CHILDREN_ARROW_NEW_LINE_TOP: 0,
      CHILDREN_BORDER_LEFT_PADDING: 0,
      CHILDREN_BORDER_RIGHT_PADDING: 0,
      CHILDREN_BORDER_BOTTOM_PADDING: scalePixelsToFontSize(2, fontSize),
      CHILDREN_BORDER_BOTTOM_MARGIN: scalePixelsToFontSize(2, fontSize),
      PARENT_MARKER_OFFSET,
      TIMELINE_BOTTOM_PADDING,
      GROUP_HEADER_HEIGHT,
      GROUP_TOP_PADDING
    };
  }
);
